<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Conference Bridge</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation" :disabled="numUsed"
            >Save</el-button
          >
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits service="Conference Room" :record="selectedConfBridge" />
      <el-tabs v-model="activeTabName">
        <!-- ⭐ GENERAL ⭐ -->
        <el-tab-pane label="General" name="general">
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="editForm.number" placeholder="Enter number"
                ><template slot="prefix">Number</template>
                <template v-if="numUsed" slot="append">
                  <in-use :inUse="numInUse" />
                </template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input v-model="editForm.name" placeholder="Enter name">
                <template slot="prefix">Name</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input v-model="editForm.pin" placeholder="Enter pin">
                <template slot="prefix">Pin</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                v-model="editForm.adminpin"
                placeholder="Enter admin pin"
              >
                <template slot="prefix">Admin pin</template>
              </el-input>
            </el-col>
          </div>
          <el-input
            v-model="editForm.sendReportEmail"
            placeholder="Enter conference report email"
          >
            <template slot="prefix">Send email report to</template>
          </el-input>
          <div>
            <el-select
              v-model="editForm.maxusers"
              placeholder="Select max allowed users"
            >
              <template slot="prefix">Max allowed users</template>
              <el-option v-for="n in 100" :key="n" :value="n">
                {{ n }}
              </el-option>
            </el-select>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Media" name="media">
          <new-mediafile @mediafileSaved="newMediaFile = $event" />

          <!-- ⭐ Request PIN Message ⭐ -->
          <existing-mediafile
            title="Request PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            :selectedMeId="editForm.requestPinMeId"
            @mediafileSelected="editForm.requestPinMeId = $event"
          />

          <!-- ⭐ Correct PIN Message ⭐ -->
          <existing-mediafile
            title="Correct PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            :selectedMeId="editForm.correctPinMeId"
            @mediafileSelected="editForm.correctPinMeId = $event"
          />

          <!-- ⭐ Correct Admin PIN Message ⭐ -->
          <existing-mediafile
            title="Correct Admin PIN Message"
            :multiple="false"
            :clearState="clearFormFields"
            :newMediafile="newMediaFile"
            :selectedMeId="editForm.correctAdminPinMeId"
            @mediafileSelected="editForm.correctAdminPinMeId = $event"
          />
        </el-tab-pane>

        <!-- ⭐ SETTINGS TAB ⭐ -->
        <el-tab-pane label="Settings" name="settings">
          <el-checkbox v-model="settings.c">Announce Users Count</el-checkbox>
          <el-checkbox v-model="settings.i">
            Announce User Join/Leave With Review
          </el-checkbox>
          <el-checkbox v-model="settings.I">
            Announce User Join/Leave Without Review
          </el-checkbox>
          <el-checkbox v-model="settings.M">
            Play MOH when only one user
          </el-checkbox>
          <el-checkbox v-model="settings.s">
            Allow Access to Menu With *
          </el-checkbox>
          <el-checkbox v-model="settings['1']">
            Do Not Play Message When First Person Enters
          </el-checkbox>
          <el-checkbox v-model="settings.w">
            Wait For Admin Before Starting Conference
          </el-checkbox>
          <el-checkbox v-model="settings.m">
            Join User Muted
          </el-checkbox>
          <el-checkbox v-model="settings.x">
            End The Conference When The Admin Leaves
          </el-checkbox>
          <el-checkbox v-model="settings.r">
            Record The Conference
          </el-checkbox>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <destination-references
      :tenantId="selectedConfBridge ? selectedConfBridge.tenantId : null"
      type="MEETME"
      :id="selectedConfBridge ? selectedConfBridge.id : null"
      :clearState="clearFormFields"
    />

  </el-dialog>
</template>

<script>
import ExistingMediafile from "@/components/ExistingMediafile";
import NewMediafile from "@/components/NewMediafile";
import RecentAudits from "@/components/RecentAudits";
import DestinationReferences from "@/components/DestinationReferences";
import InUse from "@/components/InUse";

export default {
  name: "EditConferenceBridgesForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    numInUse: { required: true },
    selectedConfBridge: { required: true }
  },

  components: { NewMediafile, ExistingMediafile, RecentAudits, InUse, DestinationReferences },

  data() {
    return {
      newMediaFile: null,
      activeTabName: "general",
      requestPinMediafile: null,
      correctPinMediafile: null,
      correctAdminPinMediafile: null,
      userChangedNum: false,
      editForm: {
        tenantId: null,
        tenantCode: null,
        name: "",
        number: "",
        pin: "",
        adminpin: "",
        requestPinMeId: "",
        correctPinMeId: "",
        correctAdminPinMeId: "",
        sendReportEmail: "",
        maxusers: 50,
        opts: "",
        adminopts: ""
      },

      settings: {
        c: false,
        i: false,
        I: false,
        M: false,
        s: false,
        1: false,
        w: false,
        m: false,
        x: false,
        r: false
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    number() {
      return this.editForm.number;
    },

    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedConfBridge(confBridge) {
      if (confBridge) {
        const { meetme } = confBridge;

        Object.keys(confBridge).forEach(key => {
          if (key in this.editForm) {
            this.editForm[key] = confBridge[key];
          }
        });

        if (meetme) {
          const { adminpin, pin, maxusers, opts } = meetme;
          this.editForm.adminpin = adminpin;
          this.editForm.pin = pin;
          this.editForm.maxusers = maxusers;

          if (opts) {
            opts
              .substr(1)
              .split("")
              .forEach(char => {
                this.settings[char] = true;
              });
          }
        }
      }
    },

    number(value) {
      if (!this.userChangedNum) {
        this.userChangedNum = true;
        return;
      }
      if (value && value !== this.selectedConfBridge.number) {
        this.$emit("checkNumber", value);
      } else {
        this.$emit("checkNumber", "****************");
      }
    }
  },

  methods: {
    clearFields() {
      this.activeTabName = "general";
      this.userChangedNum = false;
      this.requestPinMediafile = null;
      this.correctPinMediafile = null;
      this.correctAdminPinMediafile = null;

      Object.keys(this.editForm).forEach(key => {
        if (typeof this.editForm[key] === "string") {
          this.editForm[key] = "";
        }
        if (typeof this.editForm[key] === "boolean") {
          this.editForm[key] = false;
        }
        if (typeof this.editForm[key] === "number") {
          this.editForm[key] = null;
        }
      });

      this.maxusers = 50;

      this.settings = {
        c: false,
        i: false,
        I: false,
        M: false,
        s: false,
        1: false,
        w: false,
        m: false,
        x: false,
        r: false
      };
    },

    editOperation() {
      let concatStr = "";

      Object.keys(this.settings).forEach(key => {
        concatStr += this.settings[key] ? key : "";
      });

      this.editForm.opts = `T${concatStr}`;
      this.editForm.adminopts = `AaT${concatStr}`;

      this.editForm.tenantCode = this.selectedTenant.tenantCode;

      this.editForm.requestPinMeId = this.editForm.requestPinMeId
        ? this.editForm.requestPinMeId
        : 0;
      this.editForm.correctPinMeId = this.editForm.correctPinMeId
        ? this.editForm.correctPinMeId
        : 0;
      this.editForm.correctAdminPinMeId = this.editForm.correctAdminPinMeId
        ? this.editForm.correctAdminPinMeId
        : 0;

      this.$emit("editOperation", this.editForm);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.el-checkbox {
  margin-left: 0;
}
</style>
